<div class="modal-header">
    <h4 class="modal-title">Confirmation</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close(false)"></button>
</div>
<div class="modal-body">
    <p class="m-0">{{ Message }}</p>
    <p class="m-0" *ngIf="Message2 != ''">{{ Message2 }}</p>
</div>
<div class="modal-footer">

    <button type="button" class="btn btn-primary" [disabled]="isDisabled"
        (click)="close(true)"><i class="bi bi-check" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?Button1:'Loading...'}}</button>

    <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled"
        (click)="close(false)"><i class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?Button2:'Loading...'}}</button>
</div>